import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/site-data";

export default function FloatingWhatsApp() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="WhatsApp ile iletişime geç"
      className="wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={26} fill="currentColor" />
    </a>
  );
}
